 
import React from 'react';

const Settings = () => {
  return (
    <div className="settings-page">
      <h1>Settings</h1>
      <p>Settings options will be here...</p>
    </div>
  );
};

export default Settings;